// src/PrivateRoutes.js

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from './features/authSlice';
import Layout from './components/Layout';

const PrivateRoutes = () => {
    const isAuthenticated = useSelector(selectIsAuthenticated);

    return isAuthenticated ? <Layout /> : <Navigate to="/login" replace />;
};

export default PrivateRoutes;
